/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlColor1 } from './ControlColor1';
import {
    ControlColor1FromJSON,
    ControlColor1FromJSONTyped,
    ControlColor1ToJSON,
} from './ControlColor1';

/**
 * 
 * @export
 * @interface ControlGroupSummary
 */
export interface ControlGroupSummary {
    /**
     * 
     * @type {ControlColor1}
     * @memberof ControlGroupSummary
     */
    color?: ControlColor1;
    /**
     * 
     * @type {string}
     * @memberof ControlGroupSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlGroupSummary
     */
    name: string;
}

/**
 * Check if a given object implements the ControlGroupSummary interface.
 */
export function instanceOfControlGroupSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ControlGroupSummaryFromJSON(json: any): ControlGroupSummary {
    return ControlGroupSummaryFromJSONTyped(json, false);
}

export function ControlGroupSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGroupSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'color': !exists(json, 'color') ? undefined : ControlColor1FromJSON(json['color']),
        'id': json['id'],
        'name': json['name'],
    };
}

export function ControlGroupSummaryToJSON(value?: ControlGroupSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'color': ControlColor1ToJSON(value.color),
        'id': value.id,
        'name': value.name,
    };
}

